<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (type of promptTypes$ | async; track trackBy(type)) {
      <lcs-option [value]="type" id="lcs-option-id-{{ type.typeName }}">
         {{ type.typeName | addSpaces }}
      </lcs-option>
      }
   </div>
</ng-template>
